import React, { useState } from 'react';
import { bool, func, object, string } from 'prop-types';
import { Field, Form as FinalForm } from 'react-final-form';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { Form, Button, FieldTextInput, IconCollection, IconProfileCard } from '../../components';
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

import css from './UploadDocumentForm.module.css';
import { GENERAL_GPT, GENERAL_GPT_EDIT } from '../../util/types';
const ACCEPT_FILES = '.pdf,';
const ACCEPT_IMAGES = 'image/*';

const UploadDocumentFormComponent = props => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const {
    className,
    handleSubmit,
    uploadInProgress,
    uploadError,
    form,
    values,
    specificRulebookData = [],
    genralRulebook,
    handleDeleteRulebook,
    generalRulebookData = [],
    isGeneralGptEditOpen,
    isPrimaryGptEditOpen,
    primaryRulebookData
  } = props;

  const { logo_url } = (
    (genralRulebook == GENERAL_GPT_EDIT)
      ? generalRulebookData?.[0] || {}
      : isPrimaryGptEditOpen
        ? primaryRulebookData?.[0] || {}
        : (genralRulebook != GENERAL_GPT && specificRulebookData?.[0]) ? specificRulebookData?.[0] || {} : {});

  const uploadedRulebooks = (genralRulebook == GENERAL_GPT_EDIT)
    ? generalRulebookData?.length ? generalRulebookData : []
    : isPrimaryGptEditOpen
      ? primaryRulebookData?.length ? primaryRulebookData : []
      : (specificRulebookData?.length && genralRulebook !== GENERAL_GPT) ? specificRulebookData : [];


  const submitDisabled = uploadInProgress || !values?.rulebookName
    || ((genralRulebook === GENERAL_GPT_EDIT ? generalRulebookData : (values?.documentFiles ? values?.documentFiles : specificRulebookData)))?.length === 0 || !(values?.rulebookLogo || logo_url);

  //prevents from flickering issue
  const documentFileURL = values?.documentFiles || [];

  //   const handleDeleteRulebookFile = (file_id) => {
  //     handleDeleteRulebook(file_id); // Use updated state immediately

  //     // setDeletedFileIds((prev) => {
  //     //     const updatedFileIds = [...prev, file_id]; // Ensure correct array format
  //     //     handleDeleteRulebook(updatedFileIds); // Use updated state immediately
  //     //     return updatedFileIds;
  //     // });
  // };

  const handleDeleteFile = (file_id) => {
    setUploadedFiles((prev) => {
      const updatedFiles = prev.filter((file) => file.file_id !== file_id); // Remove selected file
      form.change('documentFiles', updatedFiles); // Update form state
      form.change('documentFile', null); // Reset file field in form

      // ✅ Reset file input field
      const fileInput = document.getElementById("documentFile");
      if (fileInput) {
        fileInput.value = ""; // Clear the selected file from input field
      }
      return updatedFiles; // Update state
    });
  };

  return (
    <Form onSubmit={handleSubmit} className={className}>
      <div className={css.fileInputWrapper}>
        {
          (uploadedRulebooks?.length > 0) ? (
            <div className={css.uplaodedPdf}>
              {
                uploadedRulebooks.map((url) => {
                  return <>
                    <div>
                      <span onClick={() => {
                        handleDeleteRulebook(url)
                      }}>
                        <IconProfileCard type="close" />
                      </span>
                      <iframe
                        src={`https://docs.google.com/gview?url=${url.file_url}&embedded=true`}
                      />

                      <div className={css.nameWrapper}>{url.file_name.split('.').slice(0, -1).join('.')?.slice(0, 12) + "..."}</div>
                    </div>
                  </>
                })
              }
            </div>
          )
            : null}
        {(documentFileURL?.length > 0) ?
          <div className={css.uplaodedPdf}>
            {
              documentFileURL.map((url) => {
                return <>

                  <div >
                    <span onClick={() => {
                      handleDeleteFile(url.file_id)
                    }}>
                      <IconProfileCard type="close" />
                    </span>
                    <Document file={url.documentFileView
                    }>
                      <Page pageNumber={1} width={100} height={100} />
                    </Document>
                    <div className={css.nameWrapper}>{url.file.name.split('.').slice(0, -1).join('.')?.slice(0, 12) + "..."}</div>
                  </div>
                </>
              })
            }
          </div>
          : null}

        {(((uploadedRulebooks?.length || 0) + (documentFileURL?.length || 0)) < 10)
          ? <Field
            accept={ACCEPT_FILES}
            id="documentFile"
            name="documentFile"
            label={'Add Rulebook'}
            type="file"
            form={null}
            uploadImageError={uploadError}
            disabled={false}
          >
            {fieldProps => {
              const { accept, id, input, label, disabled } = fieldProps;
              const { name, type } = input;
              const onChange = (e) => {
                const newFiles = Array.from(e.target.files); // Convert FileList to an array

                setUploadedFiles((prev) => {
                  const totalExistingFiles = prev.length;
                  const remainingSlots = 10 - totalExistingFiles;

                  if (remainingSlots <= 0) {
                    alert("You can only upload up to 10 files.");
                    return prev; // Prevent adding more files
                  }

                  const filesToAdd = newFiles.slice(0, remainingSlots); // Only take the allowed number

                  const fileData = filesToAdd.map((file) => ({
                    file,
                    file_id: crypto.randomUUID(),
                    documentFileView: URL.createObjectURL(file),
                  }));

                  const updatedFiles = [...prev, ...fileData];

                  form.batch(() => {
                    form.change("documentFiles", updatedFiles);
                  });
                  return updatedFiles; // Ensure state updates properly
                });
              };

              return (
                <div className={css.uploadAvatarWrapper}>
                  <label className={css.label} htmlFor={id}>
                    {label}
                  </label>
                  <div className={css.uploadAvatarInputWrapper}>
                    <div>
                      {
                        <>
                          <IconCollection name="uploadIcon" />
                          <div>
                            <p>
                              <FormattedMessage id="AddDocumentModal.dropFileDescription" />
                            </p>
                          </div>
                        </>
                      }
                      {<Button className={css.chooseFileButton}>
                        <FormattedMessage id="AddDocumentModal.dropFileButton" />
                      </Button>}
                    </div>
                    <input
                      accept={accept}
                      id={id}
                      name={name}
                      className={css.uploadAvatarInput}
                      disabled={disabled}
                      onChange={onChange}
                      type={type}
                      multiple
                    />
                  </div>
                  {(typeof uploadError == 'string' && uploadError) ? <FormattedMessage id="RequestRulebookForm.failedToUpload" /> : null}
                </div>
              );
            }}
          </Field>
          : null}

        {/* logo upload */}
        <Field
          accept={ACCEPT_IMAGES}
          id="rulebookLogo"
          name="rulebookLogo"
          label={'Add Rulebook logo here'}
          type="file"
          form={null}
          uploadImageError={uploadError}
          disabled={false}
        >
          {fieldProps => {
            const { accept, id, input, label, disabled } = fieldProps;

            const { name, type } = input;
            const onChange = e => {
              const file = e.target.files[0];
              if (file) {
                const uuid = crypto.randomUUID();
                form.batch(() => {
                  form.change(`rulebookLogo`, file);
                  form.change('rulebookLogoId', uuid);
                });
              }
            };
            return (
              <div className={css.uploadAvatarWrapper}>
                <label className={css.label} htmlFor={id}>
                  {label}
                </label>
                <div className={css.uploadAvatarInputWrapper}>
                  <div>
                    {(values?.rulebookLogo || logo_url) ? (
                      <img
                        src={values?.rulebookLogo ? URL.createObjectURL(values?.rulebookLogo) : logo_url}
                        alt="Preview"
                        width={'100px'}
                      />
                    ) : (
                      <>
                        <IconCollection name="uploadIcon" />
                        <div>
                          <h4>
                            <FormattedMessage id="RequestRulebookForm.rulebookLogo" />
                          </h4>
                        </div>
                      </>
                    )}
                    <Button className={css.chooseFileButton}>
                      <FormattedMessage id="RequestRulebookForm.dropImageButton" />
                    </Button>
                  </div>
                  <input
                    accept={accept}
                    id={id}
                    name={name}
                    className={css.uploadAvatarInput}
                    disabled={disabled}
                    onChange={onChange}
                    type={type}
                  />
                </div>
                {(typeof uploadError == 'string' && uploadError) ? <FormattedMessage id="RequestRulebookForm.failedToUpload" /> : null}
              </div>
            );
          }}
        </Field>

        <FieldTextInput
          className={css.inputBox}
          name="rulebookName"
          id="rulebookName"
          label="Rulebook Name"
          placeholder="Rulebook Name"
          maxLength={50}
          required
        />
      </div>

      {uploadError ? (
        <div className={css.error}>
          <FormattedMessage id="UploadDocumentForm.uploadError" values={{ error: uploadError?.message }} />
        </div>
      ) : null}

      <Button
        className={css.submitButton}
        type="submit"
        inProgress={uploadInProgress}
        disabled={submitDisabled}
      >
        <FormattedMessage id="UploadDocumentForm.upload" />
      </Button>
    </Form>
  );
};

UploadDocumentFormComponent.defaultProps = {
  className: null,
  rootClassName: null,
  uploadError: null,
  uploadInProgress: false,
};

UploadDocumentFormComponent.propTypes = {
  className: string,
  rootClassName: string,
  intl: intlShape.isRequired,
  handleSubmit: func.isRequired,
  uploadInProgress: bool,
  uploadError: string,
  form: object.isRequired,
  pristine: bool.isRequired,
  invalid: bool.isRequired,
};

const UploadDocumentForm = props => {
  const { intl } = props;

  return (
    <FinalForm
      {...props}
      validate={values => {
        // const errors = {};
        // if (!values.documentFile) {
        //   errors.documentFile = intl.formatMessage({ id: 'UploadDocumentForm.fileRequired' });
        // }
        // return errors;
      }}
      render={fieldRenderProps => <UploadDocumentFormComponent {...fieldRenderProps} />}
    />
  );
};

export default UploadDocumentForm;
